/** Sessions tab — the reusable sessions grid, fixed-filtered to this user. */
import { Box, Link, Stack } from '@mui/material';

import { SessionsGrid } from '@/features/sessions/SessionsGrid';
import { sessionsHref } from '@/utils/gridLinks';

interface Props {
  userId: number;
}

export function SessionsTab({ userId }: Props) {
  return (
    <Box>
      {/* The embedded grid has no toolbar, presets or batch ops — the full
          page does, so offer the same query there (new tab, like every other
          filter link). */}
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
        <Link
          href={sessionsHref({ user: userId })}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
        >
          Open in Sessions
        </Link>
      </Stack>
      <SessionsGrid
        fixedFilters={{ user: userId }}
        queryKeyExtra={['user', userId]}
        showUser={false}
        layout="auto"
        defaultPageSize={25}
        headerToolbar={{}}
      />
    </Box>
  );
}
